"use client";

import React from "react";
import NavBar from "../components/NavBar";
import TopHeader from "../components/topHeader";
import SearchBar from "../components/SearchBar";
import CartLogin from "../components/CartLogin";

const Header: React.FC = () => {
  return (
    <header className="bg-[var(--color-brand)] text-[var(--text-on-dark)]">
      {/* Top Header */}
      <div className="text-center py-2 text-sm lg:text-base">
        <TopHeader />
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4 py-2">
        {/* Mobile Layout — breakpoint matches NavBar/HamburgerMenu (lg), so the
            hamburger and this row switch to desktop at the same width. */}
        <div className="flex justify-between items-center gap-2 lg:hidden">
          {/* SearchBar on the left */}
          <div className="flex">
            <SearchBar />
          </div>

          {/* Hamburger Menu in the center */}
          <div className="text-2xl">
            <NavBar />
          </div>

          {/* Cart/Login on the right */}
          <div>
            <CartLogin />
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden lg:flex lg:flex-row lg:items-center lg:justify-center gap-10 xl:gap-40">
          {/* SearchBar on the left */}
          <div>
            <SearchBar />
          </div>

          {/* Navigation in the center */}
          <NavBar />

          {/* Cart/Login on the right */}
          <CartLogin />
        </div>
      </div>
    </header>
  );
};

export default Header;